import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import { request } from '@app/services';
import * as endpoints from './endpoints';
import {
  addCandidate,
  addCandidateSuccess,
  addCandidateFailed,
  getCandidates,
  getCandidatesFailed,
  getCandidatesSuccess,
  updateCandidate,
  updateCandidateFailed,
  updateCandidateSuccess,
  updateCandidateStatus,
  updateCandidateStatusSuccess,
  updateCandidateStatusFailed,
  getCandidatesDetailsByID,
  getCandidatesDetailsByIDSuccess,
  getCandidatesDetailsByIDFailed,
} from './slice';
import { RootState } from '@app/redux/root-reducer';

function* addCandidateSaga(action: ReturnType<typeof addCandidate>): any {
  try {
    const {
      firstName,
      lastName,
      personalEmail,
      phone,
      source,
      referenceBy,
      other,
      roleId,
      resume,
      applyingFor,
    } = action.payload;
    const formData = new FormData();
    formData.append('firstName', firstName);
    formData.append('lastName', lastName);
    formData.append('email', personalEmail);
    formData.append('phone', phone);
    formData.append('source', source);
    formData.append('referenceBy', referenceBy);
    formData.append('position', applyingFor);
    formData.append('other', other);
    formData.append('roleId', `${roleId}`);
    formData.append('resume', resume);
    const result = yield call(request.post, endpoints.addCandidate, formData);
    yield put(addCandidateSuccess(result.data));
  } catch (err) {
    yield put(addCandidateFailed(err));
  }
}
//
function* getCandidatesSaga(action: ReturnType<typeof getCandidates>): any {
  try {
    const query = action.payload;

    const params: Record<string, string> = {};
    if (typeof query === 'string') {
      params.q = query;
    }

    const result = yield call(request.get, endpoints.getCandidates, { params });
    yield put(getCandidatesSuccess(result.data.candidates));
  } catch (err) {
    yield put(getCandidatesFailed(err));
  }
}
//
function* getCandidatesDetailsByIdSaga(action: ReturnType<typeof getCandidatesDetailsByID>): any {
  try {
    const candidateId = action.payload;
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const result = yield call(request.get, `${endpoints.getCandidateDetails}${candidateId}`, {});
    yield put(getCandidatesDetailsByIDSuccess(result.data.user));
  } catch (err) {
    yield put(getCandidatesDetailsByIDFailed(err));
  }
}
//
function* updateCandidateSaga(action: ReturnType<typeof updateCandidate>): any {
  try {
    const {
      id,
      firstName,
      lastName,
      personalEmail,
      phone,
      source,
      referenceBy,
      other,
      resume,
      roleId,
      applyingFor,
    } = action.payload;
    const formData = new FormData();
    formData.append('firstName', firstName);
    formData.append('lastName', lastName);
    formData.append('email', personalEmail);
    formData.append('phone', phone);
    formData.append('source', source);
    formData.append('referenceBy', referenceBy);
    formData.append('position', applyingFor);
    formData.append('other', other);
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    formData.append('roleId', `${roleId}`);
    formData.append('resume', resume);
    if (id) {
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      formData.append('id', `${id}`);
    }
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const result = yield call(request.put, `${endpoints.updateCandidate}${id}`, formData);
    yield put(updateCandidateSuccess(result.data));
  } catch (err) {
    yield put(updateCandidateFailed(err));
  }
}
//
function* updateCandidateStatusSaga(action: ReturnType<typeof updateCandidateStatus>): any {
  try {
    const { id, status, reason } = action.payload;
    const { data } = yield select((store: RootState) => store.candidateReducer.candidates);
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const result = yield call(request.put, `${endpoints.updateCandidateStatus}${id}`, {
      status,
      reason,
    });
    yield put(updateCandidateStatusSuccess(result.data));
    const updateCandidate = data?.map(
      (candidates: { id: number; status: string; reason: string }) => {
        if (candidates.id === id) {
          return {
            ...candidates,
            status,
            reason,
          };
        }
        return candidates;
      }
    );
    yield put(getCandidatesSuccess(updateCandidate));
  } catch (err) {
    yield put(updateCandidateStatusFailed(err));
  }
}

function* candidateSagas() {
  yield all([
    takeLatest([getCandidates, addCandidateSuccess, updateCandidateSuccess], getCandidatesSaga),
    takeLatest(addCandidate, addCandidateSaga),
    takeLatest(updateCandidate, updateCandidateSaga),
    takeLatest(updateCandidateStatus, updateCandidateStatusSaga),
    takeLatest(getCandidatesDetailsByID, getCandidatesDetailsByIdSaga),
  ]);
}
export { candidateSagas };
